import React, { useContext, useEffect, useRef, useState } from "react";
import { http } from "../../services/httpService";
import config from "../../services/config.json";
import { context } from "../../context/context";
import { Button, Table, Tooltip, Typography, Space, Modal, Input } from "antd";
import { Tag } from "antd";
import {
    DeleteOutlined,
    EditOutlined,
    SearchOutlined,
} from "@ant-design/icons";
import { Link } from "react-router-dom";

const DiscountTable = () => {
    // search
    const [searchedColumn, setSearchedColumn] = useState("");
    const searchInput = useRef(null);
    const handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
        setSearchedColumn(dataIndex);
    };
    const handleReset = (clearFilters) => {
        clearFilters();
    };
    const getColumnSearchProps = (dataIndex) => ({
        filterDropdown: ({
            setSelectedKeys,
            selectedKeys,
            confirm,
            clearFilters,
            close,
        }) => (
            <div
                style={{
                    padding: 8,
                }}
                onKeyDown={(e) => e.stopPropagation()}
            >
                <Input
                    ref={searchInput}
                    placeholder={`جستجو`}
                    value={selectedKeys[0]}
                    onChange={(e) =>
                        setSelectedKeys(e.target.value ? [e.target.value] : [])
                    }
                    onPressEnter={() =>
                        handleSearch(selectedKeys, confirm, dataIndex)
                    }
                    style={{
                        marginBottom: 8,
                        display: "block",
                    }}
                />
                <Space>
                    <Button
                        type="primary"
                        onClick={() =>
                            handleSearch(selectedKeys, confirm, dataIndex)
                        }
                        icon={<SearchOutlined />}
                        style={{
                            width: 90,
                        }}
                    >
                        جستجو
                    </Button>
                    <Button
                        onClick={() => {
                            handleReset(clearFilters);
                            handleSearch(selectedKeys, confirm, dataIndex);
                        }}
                        style={{
                            width: 90,
                        }}
                    >
                        حذف فیلتر
                    </Button>

                    <Button
                        type="link"
                        onClick={() => {
                            close();
                        }}
                    >
                        بستن
                    </Button>
                </Space>
            </div>
        ),
        filterIcon: (filtered) => (
            <SearchOutlined
                style={{
                    color: filtered ? "#1677ff" : undefined,
                }}
            />
        ),
        onFilter: (value, record) =>
            dataIndex === "tags"
                ? record[dataIndex]
                      .toString()
                      .toLowerCase()
                      .includes(value.toLowerCase())
                : record[dataIndex]
                      .toString()
                      .toLowerCase()
                      .includes(value.toLowerCase()),
        onFilterDropdownOpenChange: (visible) => {
            if (visible) {
                setTimeout(() => searchInput.current?.select(), 100);
            }
        },
        render: (text) => (searchedColumn === dataIndex ? text : text),
    });
    //context
    const {
        forceUpdate,
        setForceUpdate,
        selectedDiscountId,
        setSelectedDiscountId,
    } = useContext(context);
    //states
    const [tableData, setTableData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [deleteIsModalOpen, setDeleteIsModalOpen] = useState(false);
    //functions
    const handleDeleteModal = () => {
        http.delete(`${config.parkopoloApi}/api/Discount/${selectedDiscountId}`)
            .then((res) => {
                setForceUpdate(20);
                console.log(res);
            })
            .catch((err) => console.log(err));
        setDeleteIsModalOpen(false);
    };
    const handleCancelModal = () => {
        setDeleteIsModalOpen(false);
    };
    //columns
    const columns = [
        {
            title: "عنوان",
            dataIndex: "title",
            width: "3%",
            ...getColumnSearchProps("title"),
        },
        {
            title: "توضیحات",
            dataIndex: "description",
            key: "description",
            width: "10%",
            render: (_, { description }) => (
                <>
                    <Typography.Paragraph>
                        <Tooltip title={description}>
                            <Typography.Paragraph style={{ cursor: "pointer" }}>
                                {description.slice(0, 25)}
                                {description.length > 25 ? "..." : null}
                            </Typography.Paragraph>
                        </Tooltip>
                    </Typography.Paragraph>
                </>
            ),
        },
        // {
        //     title: "تاریخ پایان",
        //     dataIndex: "links",
        //     key: "links",
        //     width: "10%",
        //     render: (_, { date }) => (
        //         <>
        //             <Typography.Paragraph>
        //                 {moment(date.end.slice(0, 10), "YYYY/MM/DD")
        //                     .locale("fa")
        //                     .format("YYYY/MM/DD")}
        //             </Typography.Paragraph>
        //         </>
        //     ),
        // },
        {
            title: "لینک ها",
            dataIndex: "links",
            key: "links",
            width: "10%",
            render: (_, { links }) => (
                <>
                    {links.map((link) => {
                        return (
                            <Tooltip title={link.url}>
                                <Tag color="blue" key={link._id}>
                                    {link.name
                                        ? link.name
                                        : link.url.slice(0, 8)}{" "}
                                    {/* <i
                                className={`fa ${link.icon
                                    .split(/(?=[A-Z])/)
                                    .map((word) => word.toLowerCase())
                                    .join("-")}`}
                                    style={{ fontSize: "10px" }}
                                /> */}
                                </Tag>
                            </Tooltip>
                        );
                    })}
                </>
            ),
        },
        {
            title: "تگ",
            dataIndex: "tags",
            key: "tags",
            ...getColumnSearchProps("tags"),

            width: "10%",
            render: (_, { tags }) => (
                <>
                    {tags.map((t) => {
                        return (
                            <Tag color="green" key={t}>
                                {t.toUpperCase()}
                            </Tag>
                        );
                    })}
                </>
            ),
        },
        {
            title: "عملیات",
            dataIndex: "button",
            key: "button",
            width: "10%",
            render: (text, record) => (
                <>
                    <Space style={{ width: "100%", direction: "ltr" }}>
                        <Button
                            onClick={() => {
                                setDeleteIsModalOpen(true);
                                setSelectedDiscountId(record._id);
                            }}
                            type="primary"
                            danger
                            shape="round"
                            icon={<DeleteOutlined />}
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                            }}
                        />
                        <Tooltip title="ویرایش">
                            <Link to="/editDiscount">
                                <Button
                                    onClick={() =>
                                        setSelectedDiscountId(record._id)
                                    }
                                    type="primary"
                                    icon={<EditOutlined />}
                                    style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                    }}
                                />
                            </Link>
                        </Tooltip>
                    </Space>
                </>
            ),
        },
    ];
    //api
    useEffect(() => {
        setLoading(true);
        http.get(`${config.parkopoloApi}/api/Discount/`)
            .then((res) => {
                setTableData(res.data.result);
                setLoading(false);
                // setForceUpdate(40);
            })
            .catch((err) => {
                console.log(err);
                // setForceUpdate(50);
                setLoading(false);
            });
    }, [forceUpdate]);
    console.log(tableData);
    return (
        <>
            <Table
                style={{ marginTop: "15px" }}
                size="small"
                pagination={{
                    pageSize: 10,
                    size: "default",
                    style: { position: "relative" },
                    showSizeChanger: false,
                }}
                bordered
                columns={columns}
                dataSource={tableData}
                scroll={{ x: true }}
                loading={loading}
                // onRow={(record) => {
                //   return {
                //     onClick: () => setSelectedEventId(record._id),
                //   };
                // }}
            />
            <Modal
                title="حذف کامل"
                open={deleteIsModalOpen}
                onOk={handleDeleteModal}
                onCancel={handleCancelModal}
                okText="حذف"
            >
                <p>مطمئنی میخوای حذف کنی؟</p>
            </Modal>
        </>
    );
};

export default DiscountTable;
